import bleDeviceConnectionStatus from '../../consts/bleDeviceConnectionStatus';
import BleService from './BleService';

export default class ConnectedExponentialBackOff {
    constructor(deviceId) {
        this.deviceId = deviceId;
        this.bleService = new BleService();
        this.isEnabled = true;
        this.timeout = undefined;
        this.subscribe();
    }

    onDisconectHandler = (event) => {
        if (event.data.connectionStatus === bleDeviceConnectionStatus.DISCONNECTED) {
            this.disable();
        }
    }

    subscribe() {
        const deviceClient = this.bleService.getDevice(this.deviceId);

        deviceClient.subscribeOnConnectionStatusChanged(this.onDisconectHandler);
    }

    unsubscribe() {
        const deviceClient = this.bleService.getDevice(this.deviceId);
        
        deviceClient.unsubscribeOnConnectionStatusChanged(this.onDisconectHandler);
    }

    run(max, delay, toTry, success, fail) {
        if (this.isEnabled) {
            toTry()
                .then((result) => {
                    this.unsubscribe();
                    success(result);
                })
                .catch((error) => {
                    if (max <= 0) {
                        this.unsubscribe();
                        fail(error);
                    } else {
                        if (this.isEnabled) {
                            this.timeout = setTimeout(() => {
                                this.run(--max, delay * 2, toTry, success, fail);
                            }, delay);
                        } else {
                            this.unsubscribe();
                        }
                    }
                });
        } else {
            this.unsubscribe();
        }
    }
    

    disable() {
        clearTimeout(this.timeout);
        this.isEnabled = false;
    }
}
